export default __webpack_public_path__ + "static/media/quickbookLogo-removebg-preview.7efae7d5.png";